@import url("https://fonts.googleapis.com/css2?family=Rajdhani:wght@500;600;700&display=swap");

.ch,
.ch *,
.ch *::before,
.ch *::after {
  box-sizing: border-box;
}

.ch {
  position: relative;
  background: #ffffff;
  padding-bottom: 2.5rem;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: visible;
}

.ch-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  grid-template-rows: auto 1fr;
  column-gap: 50px;
  row-gap: 0;
}

.ch-header {
  grid-column: 1;
  grid-row: 1;
  max-width: 560px;
}

.ch-body-wrap {
  grid-column: 1;
  grid-row: 2;
  max-width: 560px;
  align-self: start;
}

.ch-visual {
  grid-column: 2;
  grid-row: 1 / -1;
  align-self: center;
}

.ch-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.75rem;
}

.ch-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.ch-title {
  margin: 0 0 1.75rem 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.ch-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.ch-body {
  margin: 0 0 1.1rem 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.6;
  color: #4a4a55;
  font-weight: 500;
}

.ch-body-lead {
  font-size: clamp(1.08rem, 1.25vw, 1.25rem);
  line-height: 1.55;
  color: #2a2a32;
  font-weight: 500;
}

.ch-body:last-child {
  margin-bottom: 0;
}

.ch-video-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 4px;
  overflow: hidden;
  background: #0a0a0a;
  box-shadow:
    0 1px 2px rgba(10, 10, 10, 0.08),
    0 12px 24px rgba(10, 10, 10, 0.12),
    0 28px 60px rgba(10, 10, 10, 0.14);
}

.ch .ch-video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: cover !important;
  pointer-events: none;
  display: block;
}

.ch-video::-webkit-media-controls,
.ch-video::-webkit-media-controls-enclosure,
.ch-video::-webkit-media-controls-panel,
.ch-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none !important;
}

@media (max-width: 960px) {
  .ch-inner {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 2rem;
    column-gap: 0;
  }
  .ch-header {
    grid-column: 1;
    grid-row: auto;
    order: 1;
    max-width: none;
  }
  .ch-visual {
    grid-column: 1;
    grid-row: auto;
    order: 2;
  }
  .ch-body-wrap {
    grid-column: 1;
    grid-row: auto;
    order: 3;
    max-width: none;
  }
  .ch-title { margin-bottom: 0; }
  .ch { padding-bottom: 0; }
}

@media (max-width: 540px) {
  .ch-title {
    font-size: clamp(1.9rem, 7vw, 2.5rem);
    margin-bottom: 0;
  }
  .ch-eyebrow { margin-bottom: 1.25rem; }
}
